/*
  MyPitz product story sections (sections/mpz-pd-*.liquid).
  - .mpz-pd gets .is-in once it is first seen (entrance reveals) and .is-playing while
    on screen (looping illustrations only run then).
  - [data-pd-count]: count-up numbers.
  - .mpz-pd-stain: drives --p (0..1) through a "workday" and the clock text.
  - [data-pd-cycle]: sale timer, same shared cycle as the store's countdown section.
  - [data-pd-scroll]: buttons that scroll to the product's add to cart area.
*/
(function () {
  if (window.__mpzPd) return;
  window.__mpzPd = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- count-up ---------- */
  function countUp(el) {
    if (el.__pdCounted) return;
    el.__pdCounted = true;
    var target = parseFloat(el.getAttribute('data-pd-count'));
    var decimals = (el.getAttribute('data-pd-count').split('.')[1] || '').length;
    var suffix = el.getAttribute('data-pd-suffix') || '';
    if (isNaN(target) || reduce) { el.textContent = target.toFixed(decimals) + suffix; return; }
    var t0 = null;
    var dur = 1600;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * e).toFixed(decimals) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- workday stain demo ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function stainLoop(sec) {
    if (sec.__pdStain) return;
    sec.__pdStain = true;
    var clock = sec.querySelector('[data-pd-clock]');
    var startH = parseFloat(sec.getAttribute('data-start') || '9');
    var endH = parseFloat(sec.getAttribute('data-end') || '18');
    var run = 7000, hold = 1600, cycle = run + hold;
    var t0 = null;
    function set(p) {
      sec.style.setProperty('--p', p.toFixed(4));
      if (clock) {
        var mins = Math.round((startH + (endH - startH) * p) * 60);
        clock.textContent = pad(Math.floor(mins / 60)) + ':' + pad(mins % 60);
      }
    }
    if (reduce) { set(1); return; }
    function frame(ts) {
      if (!sec.classList.contains('is-playing')) { t0 = null; requestAnimationFrame(frame); return; }
      if (t0 === null) t0 = ts - (parseFloat(sec.style.getPropertyValue('--p')) || 0) * run;
      var t = (ts - t0) % cycle;
      var p = t < run ? t / run : 1;
      var eased = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      set(eased);
      requestAnimationFrame(frame);
    }
    set(0);
    requestAnimationFrame(frame);
  }

  /* ---------- sale timer (shared cycle anchored at 2026-01-01 00:00 UTC) ---------- */
  function timer(el) {
    if (el.__pdTimer) return;
    el.__pdTimer = true;
    var hours = parseFloat(el.getAttribute('data-pd-cycle')) || 9;
    var cycle = hours * 3600 * 1000;
    var anchor = Date.UTC(2026, 0, 1, 0, 0, 0);
    var cells = el.querySelectorAll('span');
    function tick() {
      var left = cycle - ((Date.now() - anchor) % cycle);
      var s = Math.floor(left / 1000);
      var vals = [Math.floor(s / 3600), Math.floor((s % 3600) / 60), s % 60];
      cells.forEach(function (c, i) { if (vals[i] !== undefined) c.textContent = pad(vals[i]); });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- scroll to buy ---------- */
  function scrollToBuy(e) {
    var target = document.querySelector('quantity-breaks') || document.querySelector('[id^="ProductInfo-"]') || document.querySelector('product-info');
    if (!target) return;
    e.preventDefault();
    var y = target.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
  }

  function init(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll ? scope.querySelectorAll('.mpz-pd') : [];
    if (root && root.classList && root.classList.contains('mpz-pd')) sections = [root];
    sections.forEach(function (sec) {
      if (sec.__pdInit) return;
      sec.__pdInit = true;
      sec.classList.add('pd-ready');
      if (sec.classList.contains('mpz-pd-stain')) stainLoop(sec);
      if (!('IntersectionObserver' in window)) {
        sec.classList.add('is-in', 'is-playing');
        sec.querySelectorAll('[data-pd-count]').forEach(countUp);
        return;
      }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            sec.classList.add('is-in');
            sec.querySelectorAll('[data-pd-count]').forEach(countUp);
          }
          sec.classList.toggle('is-playing', en.isIntersecting);
        });
      }, { threshold: 0.12 }).observe(sec);
      /* safety net: never leave content hidden */
      setTimeout(function () { if (sec.getBoundingClientRect().top < window.innerHeight * 1.2) sec.classList.add('is-in'); }, 2600);
    });
    scope.querySelectorAll && scope.querySelectorAll('[data-pd-cycle]').forEach(timer);
    scope.querySelectorAll && scope.querySelectorAll('[data-pd-scroll]').forEach(function (b) {
      if (b.__pdScroll) return;
      b.__pdScroll = true;
      b.addEventListener('click', scrollToBuy);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
